module.exports = __webpack_public_path__ + "static/img/bn02_01.d06be28c.jpg";